"use client";
import React from 'react';
import {DataLayerFactory} from "@/components/google-tag-manager/DataLayerFactory";
import {SingleProductQueryHook} from "@/http/api/single-product/SingleProductQueryHook";

const {useProductItemDataLayer} = new SingleProductQueryHook()


function ProductViewItemGoogleTagManager({modelId}: { modelId : number }) {
    const {mutate} = useProductItemDataLayer();
    React.useEffect(() => {

        mutate(modelId , {
            onSuccess: data => {
                if (data.result) {
                    const eventKey = `view_item_${modelId}`;
                    if (sessionStorage.getItem(eventKey)) {
                        return;
                    }


                    const viewItemDataLayer = DataLayerFactory.make(
                        'view_item',
                        { items: data.result }
                    );

                    viewItemDataLayer.pushToDataLayer();
                    sessionStorage.setItem(eventKey, 'true');
                }
            }
        })

    }, [modelId]);

    return null;
}

export default ProductViewItemGoogleTagManager;